exports.default = {
  'ask_ai': '问问AI',
  'background_color': '背景颜色',
  'reset_to_default': '恢复默认',
  'black': '黑色',
  'gray': '灰色',
  'red': '红色',
  'orange': '橙色',
  'yellow': '黄色',
  'green': '绿色',
  'blue': '蓝色',
  'purple': '紫色',
  'transparent': '透明',
  'light_gray': '浅灰色',
  'light_red': '浅红色',
  'light_orange': '浅橙色',
  'light_yellow': '浅黄色',
  'light_green': '浅绿色',
  'light_blue': '浅蓝色',
  'light_purple': '浅紫色',
  'middle_gray': '中灰色',
  'middle_red': '中红色',
  'middle_orange': '中橙色',
  'middle_yellow': '中黄色',
  'middle_green': '中绿色',
  'middle_blue': '中蓝色',
  'middle_purple': '中紫色',
  'center_align': '居中',
  'font_color': '字体颜色',
  'border_color': '边框颜色',
  'body_text': '正文',
  'heading_1': '一级标题',
  'heading_2': '二级标题',
  'heading_3': '三级标题',
  'heading_4': '四级标题',
  'heading_5': '五级标题',
  'heading_6': '六级标题',
  'heading_7': '七级标题',
  'heading_8': '八级标题',
  'heading_9': '九级标题',
  'numbered_list': '有序列表',
  'bullet_list': '无序列表',
  'task_list': '任务列表',
  'table': '表格',
  'image': '图片',
  'video': '视频',
  'audio': '音频',
  'attachment': '附件',
  'emoji': '表情',
  'code_block': '代码块',
  'quote_block': '引用块',
  'highlight_block': '高亮块',
  'dividing_line': '分割线',
  'link': '链接',
  'alignment': '对齐',
  'color': '颜色',
  'cut': '剪切',
  'copy': '复制',
  'copy_success': '复制成功',
  'delete': '删除',
  'space': '空格',
  'today_thoughts_enter': '今天有什么想法？随手输入试试看，让AI来帮你完成！',
  'continue_input_regenerate': '继续输入，重新生成',
  'thinking': '正在思考',
  'editing': '正在编辑',
  'abort_ai_editing': '你要终止Ai编辑？',
  'ai_editing_timeout': 'Ai编辑超时啦！你要保留还是放弃AI编辑？',
  'keep_or_abort_ai_editing': '你要保留还是放弃Ai编辑？',
  'ai_editing_error_end_waiting': 'AI编辑出错啦！结束等待?',
  'keep': '保留',
  'abort': '终止',
  'end': '结束',
  'give_up': '放弃',
  'cancel': '取消',
  'executing': '执行中',
  'accept': '接受',
  'insert_below': '插入下方',
  'overwrite_original': '覆盖原文',
  'try_again': '再试一次',
  'basics': '基础',
  'others': '其他',
  'markdown_format_space': 'Markdown: # 空格',
  'markdown_format_h2_space': 'Markdown: ## 空格',
  'markdown_format_h3_space': 'Markdown: ### 空格',
  'markdown_format_h4_space': 'Markdown: #### 空格',
  'markdown_format_h5_space': 'Markdown: ##### 空格',
  'markdown_format_h6_space': 'Markdown: ###### 空格',
  'markdown_format_h7_space': 'Markdown: ####### 空格',
  'markdown_format_h8_space': 'Markdown: ######## 空格',
  'markdown_format_h9_space': 'Markdown: ######### 空格',
  'markdown_format_numbered_list': 'Markdown: 1.空格',
  'markdown_format_bullet_list': 'Markdown: - 空格',
  'markdown_format_check_list': 'Markdown: [] 空格',
  'markdown_format_code_block': 'Markdown: ``` 空格',
  'markdown_format_block_quote': 'Markdown: > 空格',
  'markdown_format_horizontal_rule': 'Markdown: ---',
  'upload_image_size_cannot_exceed_10m': '上传图片大小不能超过10M!',
  'upload_file_size_cannot_exceed_20m': '上传文件大小不能超过20M!',
  'default_placeholder': '按空格唤醒AI助手，输入/使用快捷功能',
  'insert_code_block': '插入代码块',
  'insert_a_code_block': '插入一个代码块',
  'block_quote': '引用块',
  'insert_a_block_quote': '插入一个引用块',
  'insert_dividing_line': '插入分割线',
  'insert_highlight_block': '插入高亮块',
  'insert_image': '插入图片',
  'insert_video': '插入视频',
  'insert_file': '插入文件',
  'insert_table': '插入表格',
  'mermaid': '文本绘图',
  'latex': '插入公式',
  'insert_link': '插入链接',
  'insert_a_link': '插入一个链接',
  'title': '标题',
  'used_for_subsection_and_group_titles': '用于小节和分组标题',
  'left_align': '左对齐',
  'right_align': '右对齐',
  'text_align': '文本对齐',
  'hello_what_can_i_do_for_you_today': '今天我能为你做些什么？',
  'what_web_page_do_u_want': '今天想做个什么网页?',
  'create_website': '创建您的专属网站',
  'talk_to_ai': '与 AI 助手对话，描述您的需求和想法，',
  'tailored_design': '我们将为您量身定制专业的网站设计。',
  'ask_them': '问问他们',
  'your_agents': '您的智能体',
  'chat': '聊天',
  'new_conversation': '新建对话',
  'history': '历史',
  'close': '关闭',
  'intelligent_assistant_pai': '智能助手pai',
  'quick_start': '快速开始',
  'upload_image': '上传图片',
  'upload_image_cannot_exceed_10m': '上传图片大小不能超过10M!',
  'upload_file_cannot_exceed_20m': '上传文件大小不能超过20M!',
  'file_type_error': '文件类型错误!',
  'network_error_send_failed': '网络错误,发送失败。',
  'error_please_try_again_later': '报错了，请稍后重试！',
  'answer_timeout_please_try_again_later': '回答超时请稍后重试！',
  'message_contains_inappropriate_content': '您发送的消息包含不合规内容，请检查后重发！',
  'message_revoked_due_to_safety_compliance': '由于安全合规限制，该消息已撤回。',
  'continue_before_number': '继续之前编号',
  'start_new_list': '开始新列表',
  'edit_number': '修改编号值',
  'new_number_value_is': '新编号值为',
  'continue_number': '继续标题编号',
  'confirm': '确定',
  'afresh_number': '重新开始编号',
  'set_new_number': '设置标题编号',
  'from': '从',
  'start': '开始',
  'current_number_value_is': '当前编号的值为',
  'show_code_and_charts': '展示代码和图表',
  'only_show_code': '仅展示代码',
  'only_show_charts': '仅展示图表',
  'view': '视图',
  'mermaid_error_message': '输入代码即可展示图表',
  'original_size': '原始尺寸',
  'fit_to_screen': '适应屏幕',
  'zoom_in': '放大',
  'zoom_out': '缩小',
  'rotate_left': '向左旋转',
  'rotate_right': '向右旋转',
  'download_image': '下载'
}
